import type { Dispatch, SetStateAction } from "react";

import L from "leaflet";
import { useEffect, useRef } from "react";
import { Marker } from "react-leaflet";

const vertexIcon = L.divIcon({
  className: "outline-vertex-marker",
  html: '<div class="outline-vertex-innerWrap"><div class="outline-vertex-inner"></div></div>',
  iconAnchor: [7, 7],
  iconSize: [16, 16],
});

type PolygonVertexMarkersProps = {
  isEditing: boolean;
  onUpdatePoint: (index: number, point: [number, number]) => void;
  points: [number, number][];
  setDraggingVertexIndex: Dispatch<SetStateAction<null | number>>;
  setHoveredVertexIndex: Dispatch<SetStateAction<null | number>>;
};

export const PolygonVertexMarkers = ({
  isEditing,
  onUpdatePoint,
  points,
  setDraggingVertexIndex,
  setHoveredVertexIndex,
}: PolygonVertexMarkersProps) => {
  const draggingVertexIndexRef = useRef<null | number>(null);

  useEffect(() => {
    if (!isEditing) {
      draggingVertexIndexRef.current = null;
    }
  }, [isEditing]);

  return (
    <>
      {points.map((position, index) => (
        <Marker
          draggable={isEditing}
          eventHandlers={{
            dragend: (event) => {
              draggingVertexIndexRef.current = null;
              setDraggingVertexIndex(null);
              if (!isEditing) return;
              const latlng = event.target.getLatLng();
              onUpdatePoint(index, [latlng.lat, latlng.lng]);
            },
            dragstart: () => {
              if (isEditing) {
                draggingVertexIndexRef.current = index;
                setDraggingVertexIndex(index);
              }
            },
            mouseout: () => {
              if (draggingVertexIndexRef.current !== null) return;
              setHoveredVertexIndex((current) => (current === index ? null : current));
            },
            mouseover: () => {
              if (isEditing) setHoveredVertexIndex(index);
            },
          }}
          icon={vertexIcon}
          key={`vertex-${index}`}
          position={position}
        />
      ))}
    </>
  );
};
